import { NoteActionTypes } from '../constants/ApiConstants';

const initialState = {
  loading: false,
  noteTypesList: null,
  deleted_noteType: null,
  saved_noteType: null,
  noteTypeDetails: null,
};
export default (state = initialState, { type, payload }) => {
  switch (type) {
  case NoteActionTypes. get_noteTypesList.REQUEST:
    return {
      ...state,
      loading: true,
      noteTypesList: null,
    };
  case NoteActionTypes. get_noteTypesList.SUCCESS:
    return {
      ...state,
      loading: false,
      noteTypesList: payload,
    };
  case NoteActionTypes.post_noteType.REQUEST:
    return {
      ...state,
      loading: true,
      saved_noteType: null,
    };
  case NoteActionTypes.post_noteType.SUCCESS:
    return {
      ...state,
      loading: false,
      saved_noteType: payload,
    };
  case NoteActionTypes.get_noteTypeDetails.REQUEST:
    return {
      ...state,
      loading: true,
      noteTypeDetails: null,
    };
  case NoteActionTypes.get_noteTypeDetails.SUCCESS:
    return {
      ...state,
      loading: false,
      noteTypeDetails: payload,
    };
  case NoteActionTypes.delete_noteType.REQUEST:
    return {
      ...state,
      loading: true,
      deleted_noteType: null,
    };
  case NoteActionTypes.delete_noteType.SUCCESS:
    return {
      ...state,
      loading: false,
      deleted_noteType: payload,
    };
  default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/Masters/components/note-master/reducers/NoteReducers.js